export const getInitialState = (): any => ({
  trainProgressData: {}
});
